import React from 'react';
import { FadeIn } from './FadeIn';
export function PerfectFor() {
  const events = ['Weddings', 'Baby Showers', 'Quinceañeras', 'Sweet 16', 'Any special event'];
  return <section className="py-14 md:py-24 px-5 bg-dark-lighter" data-id="element-96">
      <div className="max-w-6xl mx-auto grid lg:grid-cols-2 gap-10 lg:gap-16 items-center" data-id="element-97">
        <div className="order-2 lg:order-1" data-id="element-98">
          <FadeIn data-id="element-99">
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl text-cream mb-6 md:mb-10" data-id="element-100">
              Perfect For <span className="text-gold italic" data-id="element-101">Every</span>{' '}
              Celebration
            </h2>
          </FadeIn>

          <div className="space-y-4" data-id="element-102">
            {events.map((event, index) => <FadeIn key={index} delay={0.1 * index} className="flex items-center gap-4" data-id="element-103">
                <div className="w-2 h-2 rounded-full bg-gold" data-id="element-104"></div>
                <span className="text-2xl text-cream-dark/90 font-light" data-id="element-105">
                  {event}
                </span>
              </FadeIn>)}
          </div>
        </div>

        <FadeIn direction="left" className="order-1 lg:order-2 relative" data-id="element-106">
          <div className="relative rounded-2xl overflow-hidden shadow-[0_0_40px_rgba(201,168,76,0.15)] border border-gold/20" data-id="element-107">
            <img src="https://cdn.magicpatterns.com/uploads/curCCQfUW2JcjYQ1N9tB6k/heylloyd-image-1776622381902.png" alt="TapShare Quinceañera sign" className="w-full h-auto object-cover" data-id="element-108" />
          </div>
        </FadeIn>
      </div>
    </section>;
}